/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Tokens Response Data
 * @export
 * @interface ExchangeCodeForTokens200Response
 */
export interface ExchangeCodeForTokens200Response {
    /**
     * Access Token
     * @type {string}
     * @memberof ExchangeCodeForTokens200Response
     */
    accessToken: string;
    /**
     * ID Token
     * @type {string}
     * @memberof ExchangeCodeForTokens200Response
     */
    idToken: string;
    /**
     * Token Type
     * @type {string}
     * @memberof ExchangeCodeForTokens200Response
     */
    tokenType: string;
    /**
     * Expires In
     * @type {number}
     * @memberof ExchangeCodeForTokens200Response
     */
    expiresIn: number;
    /**
     * Refresh Token
     * @type {string}
     * @memberof ExchangeCodeForTokens200Response
     */
    refreshToken: string;
}

/**
 * Check if a given object implements the ExchangeCodeForTokens200Response interface.
 */
export function instanceOfExchangeCodeForTokens200Response(value: object): value is ExchangeCodeForTokens200Response {
    if (!('accessToken' in value) || value['accessToken'] === undefined) return false;
    if (!('idToken' in value) || value['idToken'] === undefined) return false;
    if (!('tokenType' in value) || value['tokenType'] === undefined) return false;
    if (!('expiresIn' in value) || value['expiresIn'] === undefined) return false;
    if (!('refreshToken' in value) || value['refreshToken'] === undefined) return false;
    return true;
}

export function ExchangeCodeForTokens200ResponseFromJSON(json: any): ExchangeCodeForTokens200Response {
    return ExchangeCodeForTokens200ResponseFromJSONTyped(json, false);
}

export function ExchangeCodeForTokens200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExchangeCodeForTokens200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'accessToken': json['access_token'],
        'idToken': json['id_token'],
        'tokenType': json['token_type'],
        'expiresIn': json['expires_in'],
        'refreshToken': json['refresh_token'],
    };
}

export function ExchangeCodeForTokens200ResponseToJSON(value?: ExchangeCodeForTokens200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'access_token': value['accessToken'],
        'id_token': value['idToken'],
        'token_type': value['tokenType'],
        'expires_in': value['expiresIn'],
        'refresh_token': value['refreshToken'],
    };
}

